import React from 'react'
import { IconButton, Grid, Tooltip } from '@mui/material'
import { DirectionsCar } from '@mui/icons-material'
import { useLang } from '~/hooks/useLang'
import { useHookstate } from '@hookstate/core'
import AddVehicleDialog from './components/AddVehicleDialog'

export default function AddVehicleButton({ canAddVehicles }) {
  const { translate } = useLang()
  const open = useHookstate(false)

  return (
    <Grid item>
      <Tooltip
        title={translate('Add Vehicle')}
        placement="right-start"
        componentsProps={{
          tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } },
        }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton disabled={!canAddVehicles} onClick={() => open.set(true)}>
            <DirectionsCar />
          </IconButton>
        </span>
      </Tooltip>
      {open.get() && <AddVehicleDialog open={open} />}
    </Grid>
  )
}
